import { render, staticRenderFns } from "./TabelaDeAditivos.vue?vue&type=template&id=b18e16ce&scoped=true"
import script from "./TabelaDeAditivos.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeAditivos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeAditivos.vue?vue&type=style&index=0&id=b18e16ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18e16ce",
  null
  
)

export default component.exports